module.exports = __webpack_public_path__ + "img/ac-desktop-default.532870b0.png";